import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Tasks from './pages/Tasks';
import Meals from './pages/Meals';
import CalendarPage from './pages/CalendarPage';
import Kids from './pages/Kids';
import Layout from './components/Layout';
import { useAuth } from './AuthContext';

function App() {
  const { user } = useAuth();

  return (
    <Router>
      {/* Pass the user state as a prop to your Layout */}
      <Layout user={user}>
        <Routes>
          {!user ? (
            <Route path="*" element={<Home />} />
          ) : (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/meals" element={<Meals />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/kids" element={<Kids />} />
          </>
          )}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;

